import angular from 'angular';
import { get, map } from 'lodash';
import moment from 'moment-timezone';

import '../../../services/appointment';
import '../../../services/place';
import '../../../services/area';
import '../../../services/organization';
import { localStorage } from '../../../utils';
import '../../modals/checkin-process';

const module = angular.module('whyline.controllers.confirm-by-qr', [
  'whyline.services.appointment',
  'whyline.services.place',
  'whyline.services.area',
  'whyline.modals.checkin-process',
  'whyline.services.organization',
]);

const AppointmentConfirmController = (
  AppointmentService,
  PlaceService,
  $scope,
  $location,
  $translate,
  $uibModal,
  AreaService,
  $timeout,
  OrganizationService,
) => {
  const { token } = $location.search();
  const { placeId } = $location.search();
  $scope.people = 1;
  $scope.success = false;
  $scope.error = false;
  $scope.appointmentDate = '';
  $scope.alreadySelectedProcess = '';
  $scope.customFieldsToShow = [];
  const successMessage = () => {
    $scope.success = true;
    $scope.error = false;
    $scope.message = $translate.instant('appointment.qr-scan.confirmed-success');
  };

  const errorMessage = (error) => {
    $scope.success = false;
    $scope.error = true;
    const message = get(error.data, 'message', '');
    switch (message) {
      case 'appointment.not-found':
        $scope.message = $translate.instant('appointment.not-found');
        break;
      case 'appointment.already-canceled':
      case 'appointment.too-late':
        $scope.message = $translate.instant('appointment.qr-scan.overdue-or-canceled', {
          minutes: error.checkInMax,
        });
        break;
      case 'appointment.too-early':
        $scope.message = $translate.instant('appointment.qr-scan.too-early', {
          minutes: error.checkInMin,
        });
        break;
      case 'appointment.cannot-checked-in':
      case 'appointment.already-checked-in':
        $scope.message = $translate.instant('appointment.qr-scan.already-checked-in');
        break;
      case 'not-authorized':
        $scope.message = $translate.instant('not-authorized');
        break;
      case 'appointment.check-in.area-required':
        $scope.message = $translate.instant('area_required');
        break;
      case 'appointment.check-in.areas-missmatching':
        $scope.message = $translate.instant('areas-missmatching');
        break;
      default:
        $scope.message = $translate.instant('default_case');
        break;
    }
  };

  const setAppointmentData = (appointment) => {
    $scope.people = get(appointment, 'people', 1);
    const appointmentCustomFields = get(appointment, 'person.customFields');
    const customFieldsKeys = Object.keys(appointmentCustomFields);
    for (const key of customFieldsKeys) {
      const field = $scope.customFields.find(cf => cf.name === key);
      if (field && field.showInAlias) {
        $scope.customFieldsToShow.push({key: key, value: appointmentCustomFields[key], type: field.type});
      }
    }
    $scope.date =
      get(appointment, 'type', 'appointment') === 'appointment'
        ? get(appointment, 'appointment.date', null)
        : get(appointment, 'subscriptionTime', null);
  };

  const checkIn = (place) => {
    if (token && placeId) {
      const CHECK_IN_MIN = 15;
      const CHECK_IN_MAX = 15;
      const checkInMin = get(place, 'configuration.checkIn.min', CHECK_IN_MIN);
      const checkInMax = get(place, 'configuration.checkIn.max', CHECK_IN_MAX);

      $scope.placeUTCOffset = moment.tz(place.timezone).format('Z').toString();

      if (get(place, 'configuration.canProcessAppointment', false)) {
        AppointmentService.ProcessByToken(token, placeId, $scope.alreadySelectedProcess._id)
          .then((response) => {
            setAppointmentData(response);
            successMessage();
          })
          .catch((error) => {
            setAppointmentData(error.data.data);
            error.checkInMin = checkInMin;
            error.checkInMax = checkInMax;
            errorMessage(error);
          });
      } else {
        AppointmentService.CheckInByQRCode(token, placeId, $scope.alreadySelectedProcess._id)
          .then((response) => {
            setAppointmentData(response);
            successMessage();
          })
          .catch((error) => {
            setAppointmentData(error.data.data);
            error.checkInMin = checkInMin;
            error.checkInMax = checkInMax;
            errorMessage(error);
          });
      }
    }
  };

  PlaceService.GetOneAsPromiseFromServer(placeId).then((place) => {
    $scope.place = place;
    PlaceService.SetCurrent(place);
    OrganizationService.GetOneAsPromise(place.organizationId).then(org => {
      $scope.customFields = get(org, 'configuration.customFields');
      $scope.mustSelectProcess = get(place, 'configuration.checkIn.mustSelectProcess', false);
      if (!$scope.mustSelectProcess) {
        checkIn($scope.place);
      } else {
        $scope.alreadySelectedProcess = localStorage.get('checkin-process');
        if (!$scope.alreadySelectedProcess) {
          $scope.changeSelectedArea();
        } else {
          checkIn($scope.place);
        }
      }
    })
  });

  $scope.changeSelectedArea = () => {
    localStorage.remove('checkin-process');
    const modalInstance = $uibModal.open({
      templateUrl: '/templates/components/modals/checkin-process.html',
      size: 'md',
      controller: 'CheckinProcessModalController',
    });
    modalInstance.result.then((area) => {
      $scope.alreadySelectedProcess = area;
      checkIn($scope.place);
    });
  };
};

module.exports = module.controller('ConfirmByQRCodeScreenController', AppointmentConfirmController);
